"use client";
import { jsx } from "react/jsx-runtime";
import { cn } from "../utils.js";
import * as __rspack_external_react from "react";
import * as __rspack_external__radix_ui_react_tabs_62268d7a from "@radix-ui/react-tabs";
const Tabs = __rspack_external__radix_ui_react_tabs_62268d7a.Root;
const TabsList = /*#__PURE__*/ __rspack_external_react.forwardRef(({ className, ...props }, ref)=>/*#__PURE__*/ jsx(__rspack_external__radix_ui_react_tabs_62268d7a.List, {
        ref: ref,
        className: cn(className),
        ...props
    }));
TabsList.displayName = __rspack_external__radix_ui_react_tabs_62268d7a.List.displayName;
const TabsTrigger = /*#__PURE__*/ __rspack_external_react.forwardRef(({ className, ...props }, ref)=>/*#__PURE__*/ jsx(__rspack_external__radix_ui_react_tabs_62268d7a.Trigger, {
        ref: ref,
        className: cn(className),
        ...props
    }));
TabsTrigger.displayName = __rspack_external__radix_ui_react_tabs_62268d7a.Trigger.displayName;
const TabsContent = /*#__PURE__*/ __rspack_external_react.forwardRef(({ className, ...props }, ref)=>/*#__PURE__*/ jsx(__rspack_external__radix_ui_react_tabs_62268d7a.Content, {
        ref: ref,
        className: cn(className),
        ...props
    }));
TabsContent.displayName = __rspack_external__radix_ui_react_tabs_62268d7a.Content.displayName;
export { Tabs, TabsContent, TabsList, TabsTrigger };
